import React from "react";
import { Link } from "react-router-dom";

export function PageHeader({ title, subtitle, right }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-7">
      <div>
        <div className="text-[11px] tracking-[0.3em] text-demon-muted mb-1">THE MONEY CLUB · 92 DAYS CHALLENGE</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-glow">{title}</h1>
        {subtitle && <p className="text-demon-muted text-sm mt-1">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function GoalBar({ label, current, target, start = 350, color = "violet", testid }) {
  const pct = Math.min(100, Math.max(0, ((current - start) / (target - start)) * 100));
  const grad =
    color === "gold"
      ? "linear-gradient(90deg,#d97706,#f59e0b,#fbbf24)"
      : "linear-gradient(90deg,#6d28d9,#a855f7,#c084fc)";
  return (
    <div data-testid={testid}>
      <div className="flex justify-between items-baseline mb-2">
        <span className="text-xs tracking-widest text-demon-muted">{label}</span>
        <span className="font-mono text-sm font-bold text-white">{pct.toFixed(2)}%</span>
      </div>
      <div className="h-3 rounded-full bg-black/60 border border-violet-900/40 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-700"
          style={{ width: `${pct}%`, background: grad, boxShadow: "0 0 12px rgba(168,85,247,0.5)" }}
        />
      </div>
      <div className="flex justify-between mt-1 font-mono text-[11px] text-demon-muted">
        <span>${start.toLocaleString("en-US")}</span>
        <span>${target.toLocaleString("en-US")}</span>
      </div>
    </div>
  );
}

export function Stat({ label, value, accent = "silver", testid }) {
  const color =
    accent === "green"
      ? "text-emerald-400"
      : accent === "red"
      ? "text-red-400"
      : accent === "gold"
      ? "text-amber-400 gold-glow"
      : accent === "violet"
      ? "text-violet-300 text-glow"
      : "text-white";
  return (
    <div className="glow-card rounded-xl p-4" data-testid={testid}>
      <div className="text-[10px] tracking-widest text-demon-muted mb-1">{label}</div>
      <div className={`font-mono text-xl sm:text-2xl font-bold ${color}`}>{value}</div>
    </div>
  );
}

export function DisclaimerFooter() {
  return (
    <div className="mt-12 border-t border-violet-900/30 pt-5 text-[11px] leading-relaxed text-demon-muted/80">
      Materiały mają charakter wyłącznie edukacyjny i informacyjny i nie stanowią porady ani rekomendacji
      inwestycyjnej. Trading wiąże się z wysokim ryzykiem utraty kapitału. Każdy uczestnik podejmuje decyzje
      samodzielnie i na własną odpowiedzialność.{" "}
      <Link to="/disclaimer" className="text-violet-400 hover:underline">
        Pełny disclaimer &amp; ostrzeżenie o ryzyku →
      </Link>
    </div>
  );
}
